import DojoView from "csi/page/DojoView";
import { Box, FlexColumn, Message } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { useColorwayAllocationManageStore } from "./ColorwayAllocationManageStore";

export const UpdateSupplierRequestTable = observer(() => {
	const store = useColorwayAllocationManageStore();
	const { viewParams, actionSourceNode } = store;

	const titleRes = actionSourceNode.$Type === "StyleSourcing" 
		? "ManageColorwayAllocation_SR_Update_Message" 
		: "ManageColorMaterialAllocation_SR_Update_Message";

	return (
		<FlexColumn p={5}>
			<Box mb={1.5}>
				<Message
					titleRes={titleRes}
					variant="info"
				/>
			</Box>
			<Box growNoOverflow>
				<DojoView 
					fullHeight 
					nodeUrl={actionSourceNode.$URL} 
					viewId="UpdateSupplierRequestPerActiveColor" 
					viewNodeType={actionSourceNode.$Type}
					viewParams={viewParams}
				/>
			</Box>
		</FlexColumn>
	);
});